import {connect, useDispatch} from "react-redux";
import React, {useEffect} from "react";
import {Row, Container, Table, Col} from "reactstrap";
import {useTranslation} from "react-i18next";
import QRCode from "qrcode.react";
import { clearSubmenuSelected } from "../../../../store/ducks/dadosAcervo";

/**
 * @author Renan Salustiano <renan.salustano@ter.grupomarista.org.br>
 * @param dadosProtocoloArmazem
 * @returns {JSX.Element}
 * @constructor
 */
const DadosProtocoloArmazem = ({ dadosProtocoloArmazem, instituicaoRx }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { gerar_qrcode, protocolo_gerado, dados_protocolo } = dadosProtocoloArmazem;

    /**
     * Dados do qr code exatamente como são gerados na versão legada
     * @returns {`Protocolo: ${string}\n\nPor favor, anote o Número do Protocolo e dirija-se ao setor de Acervos Fechados para retirada dos respectivos exemplares.`}
     */
    const getDadosQrCode = () => {
        return `Protocolo: ${protocolo_gerado}\n\n` + t('PorFavorAnoteNumeroProtocoloAcervoFechado', {acervoFechado: (instituicaoRx.desc_armazem || t('AcervoFechado'))})
    }

    return (<Container>
        <Row className={'p-2'}>
            <Col md={'2'}>
               <a  className="cortxt negrito s13 m-0 link click" onClick={e => {
                   dispatch(clearSubmenuSelected())
               }}>
                   Voltar
               </a>
            </Col>
            <Col md={'10'}>
                <label className="f500 cortxt s13 m-auto">
                    {
                        protocolo_gerado && t('PorFavorAnoteNumeroProtocoloAcervoFechado', {acervoFechado: (instituicaoRx.desc_armazem || t('AcervoFechado'))}) || 'Protocolo não gerado.'
                    }
                </label>
            </Col>
        </Row>
        {
            dados_protocolo && (
                <>
                    <Table
                        responsive
                        className="s10 preto70 text-center"
                    >
                        <thead>
                        <tr>
                            <th>{t('Protocolo')}</th>
                            <th className={'text-left'} >{t('Acervo')}</th>
                            <th>{t('Informacao')}</th>
                            <th>{t('Status')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            dados_protocolo?.length && dados_protocolo.map( ({cod_acervo, titulo, mensagem_erro}) => (
                                <tr>
                                    <td>{mensagem_erro === 'OK' ? protocolo_gerado :  ''}</td>
                                    <td className={'text-left'}>{cod_acervo} - {titulo}</td>
                                    <td className={mensagem_erro !== 'OK' ? 'laranja' : ''}>{mensagem_erro ===  'OK' ? '' : mensagem_erro}</td>
                                    <td className={mensagem_erro !== 'OK'? 'laranja' : 'text-success'}>{mensagem_erro === 'OK' ?  'Sucesso' : t('Atencao')}</td>
                                </tr>
                            ))
                        }

                        </tbody>
                    </Table>
                    {
                       gerar_qrcode && protocolo_gerado && (
                           <Row>
                               <Col md={'3'} className="d-flex justify-content-center align-items-center">
                                   <QRCode
                                       value={getDadosQrCode()}
                                       size={200}
                                       renderAs="svg"
                                       className="cortxt qrcode"
                                       level="L"
                                       includeMargin
                                   />
                               </Col>
                               <Col md={'9'} className="d-flex justify-content-center align-items-center">
                                   <p className="f500 cortxt s13 m-auto">Instale em seu dispositivo mobile um leitor de QR Code e leve com você as referências desse material.</p>
                               </Col>
                           </Row>
                        )
                    }

                </>

            )
        }

    </Container>)
}


const mapStateToProps = state => ({
    dadosProtocoloArmazem: state.dadosAcervo.dadosProtocoloArmazem,
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(DadosProtocoloArmazem);
